import DestinationPage from '../../src/pages/DestinationPage';

export default DestinationPage;
